import React from 'react';
import { LottiePlayer } from 'lottie/lottie';
import scss from './CircularProgress.module.scss'

interface Props {
  className?: string
  cssLoader?: boolean
}

export default function Loading(props: Props) {
  const { className, cssLoader = false } = props;

  return cssLoader ? <div className={`${scss.loader_container} project_loader`}>
    <div className={scss.loader} >
      <section className={scss.mask} />
    </div>
  </div>
    : <LottiePlayer className={className} />
}

